import { apiCreate, apiDelete } from './ApiBaseActions';
export const API_CAN_CREATE_PROFESSIONAL_RFP_MEMBER = 'API_CAN_CREATE_PROFESSIONAL_RFP_MEMBER';
export const API_CREATE_PROFESSIONAL_RFP_MEMBER = 'API_CREATE_PROFESSIONAL_RFP_MEMBER';
export const API_DELETE_PROFESSIONAL_RFP_MEMBER = 'API_DELETE_PROFESSIONAL_RFP_MEMBER';
/**
 * @deprecated TS化 src/actions/rfpProMemberActions/create.ts
 */
export const apiCanCreateProfessionalRfpMember = (id, values, meta) => apiCreate(API_CAN_CREATE_PROFESSIONAL_RFP_MEMBER, `/professional/rfp/${id}/can_add_member`, values, Object.assign({ id }, (meta || {})));
/**
 * @deprecated TS化 src/actions/rfpProMemberActions/create.ts
 */
export const apiCreateProfessionalRfpMember = (id, values, meta) => apiCreate(API_CREATE_PROFESSIONAL_RFP_MEMBER, `/professional/rfp/${id}/add_member`, values, Object.assign({ id }, (meta || {})));
/**
 * @deprecated TS化 src/actions/rfpProMemberActions/delete.ts
 */
export const apiDeleteProfessionalRfpMember = (id, memberId, meta) => apiDelete(API_DELETE_PROFESSIONAL_RFP_MEMBER, `/professional/rfp/${id}/delete_member/${memberId}`, Object.assign({ id, memberId }, (meta || {})));
